import React from 'react';
import { TabbedForm, TextInput, DateInput, ReferenceInput, AutocompleteInput, SelectInput, ArrayInput, SimpleFormIterator } from 'react-admin';

import Create from '../common/views/Create';
import RichTextInput, { FullRichTextInputToolbar } from '../common/inputs/RichTextInput';
import ColorInput from '../common/inputs/ColorInput';
import StatusInput from './inputs/StatusInput';
import CategoryInput from './inputs/CategoryInput';

const optionText = choice => choice.name ? choice.name : '';
const userOptionText = choice => choice ? choice?.fullname : '';

const formSx = {
    '&& .RaArrayInput-root': {
        minWidth: '100% !important'
    }
};

const simpleFormIteratorSx = {
    '& .RaSimpleFormIterator-line': {
        padding: '15px 0'
    }
};

const ProjectCreate = (props) => (
    <Create {...props}>
        <TabbedForm sx={formSx}>
            <TabbedForm.Tab label="Summary">
                <TextInput source="name" />
                <TextInput source="alias" />
                <ReferenceInput source="customer_id" reference="customers" sort={{ field: 'name', order: 'ASC' }}>
                    <AutocompleteInput optionText={optionText} size="small" label="Customer" />
                </ReferenceInput>
                <CategoryInput />
                <StatusInput />

                <ArrayInput source="users" fullWidth sx={{ minWidth: '100% !important' }}>
                    <SimpleFormIterator inline sx={simpleFormIteratorSx}>
                        <TextInput source="role" helperText={false} />
                        <ReferenceInput reference="users" source="user_id">
                            <AutocompleteInput label="Internal user" optionText={userOptionText} clearOnBlur={false} helperText={false} />
                        </ReferenceInput>
                        <TextInput source="name" label="External user" helperText={false} />
                    </SimpleFormIterator>
                </ArrayInput>

                {/* <ReferenceArrayInput reference="users" source="user_ids">
                    <AutocompleteArrayInput optionText={userOptionText} clearOnBlur={false} label="Users" />
                </ReferenceArrayInput> */}
                <DateInput source="start_date" />
                <DateInput source="end_date" />
                <ColorInput sx={{ marginBottom: '16px' }} />
                <ReferenceInput source="redmine_id" reference="redmine/projects" sort={{ field: 'name', order: 'ASC' }}>
                    <SelectInput label="Redmine project" />
                </ReferenceInput>
                <RichTextInput source="description" toolbar={<FullRichTextInputToolbar />} />
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Links">
                <TextInput source="google_drive_url" label="Google Drive" type="url" fullWidth />
                <TextInput source="redmine_url" label="Redmine" type="url" fullWidth />
                <TextInput source="gitlab_url" label="GitLab" type="url" fullWidth />
                <TextInput source="figma_url" label="Figma" type="url" fullWidth />
            </TabbedForm.Tab>
        </TabbedForm>
    </Create>
);

export default ProjectCreate;
